export default "__VITE_ASSET__CgnvldEK__"